"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "largeTitleClassNames", {
    enumerable: true,
    get: function() {
        return _useLargeTitleStylesstyles.largeTitleClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./LargeTitle"), exports);
const _useLargeTitleStylesstyles = require("./useLargeTitleStyles.styles");
